import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';

import './big-button.css';
import ImageMapper from 'react-img-mapper';

import blank1080 from '../Common/blank-1080x210.png'
import blank512 from '../Common/blank-512x512.png'

const OFF_ID = 1
const CHOOSE_ACTIONS_ID = 4;
const SELECT_ACTION_ID = 5;
const EXECUTE_ACTION_ID = 6;
const END_TURN_ID = 8

function TopLeftButton(props) {

    const AREAS = [{
        "shape": "poly",
        "coords": [0,0, 0,100, 100,0],
        "fillColor": "rgba(143,143,143,0.44)"
    }];

    const MAP = {
        name: `workmap-top-left`,
        areas: AREAS
    }

    const src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

    return <div id={'top-left-button-anchor'} className={'top-left-button-anchor'}>
        <div className={'top-left-button-text'}>Pink Ponies</div>
        <ImageMapper src={src} map={MAP}
                     onClick={() => {console.log('click')}}
                     width={60}
                     stayHighlighted={false}
                     stayMultiHighlighted={false}
                     toggleHighlighted={false}
                     rerenderProps={[]}
        />
    </div>;
}

export class BigButton2 extends Component {

    constructor(props) {
        super(props);
        this.state = {message: 'Skip', tick: 0};
        this.callback = null;
        // Live-data subscription, mirroring ActionSelector. BigButton2's
        // visibility gates on turn_status, but rendering off the handed-down
        // React prop lagged the seated controller by at least one cycle: a
        // SELECT_ACTION patch that fanned out on the per-seat event without
        // re-flowing props left the Skip/End-Turn button hidden behind a stale
        // ACTION_COMPLETE turn_status. Subscribe to the same per-seat channel
        // ActionSelector uses and read the controller's authoritative
        // gamePlayerData in render() so the button tracks the live seat.
        const game = this.props.app && this.props.app.game;
        this.seatedController = game ? game.seatedController : null;
        this.gamePlayerEventName = this.props.gamePlayerData
            ? `game-player-${this.props.gamePlayerData.seat}-event` : null;
    }

    componentDidMount() {
        if (this.gamePlayerEventName) {
            window.addEventListener(this.gamePlayerEventName, this.onSeatTick);
        }
    }

    componentWillUnmount() {
        if (this.gamePlayerEventName) {
            window.removeEventListener(
                this.gamePlayerEventName, this.onSeatTick);
        }
    }

    onSeatTick = () => {
        this.setState((s) => ({tick: s.tick + 1}));
    };

    effectiveGamePlayerData = () => {
        if (this.seatedController && this.props.gamePlayerData
                && this.props.gamePlayerData.seat
                    === this.seatedController.seat) {
            return this.seatedController.gamePlayerData;
        }
        return this.props.gamePlayerData;
    };

    clickedOn = () => {
        if (this.callback) {
            this.callback();
            this.clearCallback();
            return;
        }
        this.props.app.game.seatedController.gamePlayerApi.clickNext();
    };

    setCallback = (callback, message) => {
        this.callback = callback;
        this.setState({message: message});
    };

    clearCallback = () => {
        this.callback = null;
        this.setState({message: 'Skip'});
    };

    render() {
        let gamePlayerData = this.effectiveGamePlayerData();
        if (!gamePlayerData) {
            return <></>;
        }
        let message = this.state.message;
        let turnStatus = gamePlayerData.turn_status;

        let showDuring = [SELECT_ACTION_ID, EXECUTE_ACTION_ID];
        if (!showDuring.includes(turnStatus)) return <></>


        return <div id={'big-button'} className={'big-button'}>
            <div className={'big-button-overlay'}>
                <img src={blank1080} alt={'big-button'}
                     onClick={this.clickedOn}
                     className={'big-button-image'}
                />
            </div>
            <div className={'big-button-item'}>
                <img src={blank512} alt={'big-button'}
                     onClick={this.clickedOn}
                     className={'big-button-image'}
                />
                <div className={'big-button-item-text-anchor'}>
                    <div className={'big-button-item-text'}
                         onClick={this.clickedOn}>{message}</div>
                </div>
            </div>
            <div className={'big-button-item'}>
                <img src={blank512} alt={'big-button'}
                     onClick={this.clickedOn}
                     className={'big-button-image'}
                />
                <div className={'big-button-item-text-anchor'}>
                    <div className={'big-button-item-text'}
                         onClick={this.clickedOn}>{message}</div>
                </div>
            </div>
            <div className={'big-button-item'}>
                <img src={blank512} alt={'big-button'}
                     onClick={this.clickedOn}
                     className={'big-button-image'}
                />
                <div className={'big-button-item-text-anchor'}>
                    <div className={'big-button-item-text'}
                         onClick={this.clickedOn}>{message}</div>
                </div>
            </div>
            <div className={'big-button-item'}>
                <img src={blank512} alt={'big-button'}
                     onClick={this.clickedOn}
                     className={'big-button-image'}
                />
                <div className={'big-button-item-text-anchor'}>
                    <div className={'big-button-item-text'}
                         onClick={this.clickedOn}>{message}</div>
                </div>
            </div>
            <div className={'big-button-item'}>
                <img src={blank512} alt={'big-button'}
                     onClick={this.clickedOn}
                     className={'big-button-image'}
                />
                <div className={'big-button-item-text-anchor'}>
                    <div className={'big-button-item-text'}
                         onClick={this.clickedOn}>{message}</div>
                </div>
            </div>
            <div className={'big-button-item'}>
                <img src={blank512} alt={'big-button'}
                     onClick={this.clickedOn}
                     className={'big-button-image'}
                />
                <div className={'big-button-item-text-anchor'}>
                    <div className={'big-button-item-text'}
                         onClick={this.clickedOn}>{message}</div>
                </div>
            </div>
        </div>;
    }

}

